import {clsx, type ClassValue} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

// Custom --spacing-* tokens (styles/*.css); without this, p-0 can't override p-dialogs-padding etc.
const isCustomSpacing = (value: string) =>
  /^(space|buttons|gutter|tags|tabs|badges|tables|context|filters|column|navigation|dialogs|border|form|date|sections|margins|grid|widgets|popovers|list|empty|breakpoints|alert|toast|right|left|illlustrations|full|entities|brand)-/.test(
    value,
  );

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: [isCustomSpacing],
    },
    classGroups: {
      // Register text-label-* as font-size classes so they don't conflict with text colors
      'font-size': [{text: ['label-sm', 'label-md', 'label-lg', 'header-sm', 'header-md', 'header-lg']}],
    },
  },
});

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
